module.exports = __webpack_public_path__ + "097e343b80bad98285c062399045e6a7.jpg";


//////////////////
// WEBPACK FOOTER
// ../~/file-loader!../loaders/scale-loader?size=700!./images/projekte/theater-2016.jpg
// module id = 678
// module chunks = 0